import { render, staticRenderFns } from "./cardDialog.vue?vue&type=template&id=42c26baa&scoped=true"
import script from "./cardDialog.vue?vue&type=script&lang=js"
export * from "./cardDialog.vue?vue&type=script&lang=js"
import style0 from "./cardDialog.vue?vue&type=style&index=0&id=42c26baa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c26baa",
  null
  
)

export default component.exports